import React, { useState } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { Button } from '@fiverr-private/button';
import { Heading, Text } from '@fiverr-private/typography';
import { PlayCircleSolidIcon } from '@fiverr-private/visuals';
import { BriefCreationHowToModal, HowToMiraModal } from '@fiverr-private/dm_brief_creation';
import { MiraBriefsEmptyState } from '@fiverr-private/mira_entry_points';
import { getContext } from '@fiverr-private/fiverr_context';
import { CreateBriefButton } from '../../CreateBriefButton';
import { AppI18n } from '../../../i18n';
import { useInitialProps } from '../../../context';
import { PAGE_NAME } from '../../../../../configuration/constants';
import EmptyBriefs from '../../../../assets/empty-briefs.gif';
import { getMiraBriefsEmptyStateVariant } from './utils';

export const NoBriefsState = () => {
  const { rollouts } = useInitialProps();
  const [isHowItWorksOpen, setIsHowItWorksOpen] = useState(false);
  const { abTests } = getContext();

  // Same experiment as the header CTA (CreateBriefButton): group A (control) or not allocated is the
  // existing lobby flow below, unchanged; groups B-D render MiraBriefsEmptyState (chat/miniFlow/orbit).
  // This entry point's own allocation request (miraEntryPointsEmptyState) only allocates buyers with 0
  // briefs, so it never competes with the header CTA's allocation for the same buyer.
  const miraVariant = rollouts?.inPythonsMiraEntryPoints ? getMiraBriefsEmptyStateVariant(abTests) : null;

  if (miraVariant) {
    // Unlike `now`, these variants draw the Brief creator themselves, so the host renders nothing else
    // beside the card itself. BriefsScene is a fixed-width column that doesn't center itself, so the host
    // still centers it (as the design does).
    return (
      <Stack direction="column" alignItems="center" justifyContent="center" minHeight="60vh">
        <MiraBriefsEmptyState
          variant={miraVariant}
          source={PAGE_NAME}
          onSeeHowItWorks={() => setIsHowItWorksOpen(true)}
        />
        <HowToMiraModal isOpen={isHowItWorksOpen} onClose={() => setIsHowItWorksOpen(false)} />
      </Stack>
    );
  }

  return (
    <Stack gap="14" direction="column" alignItems="center" justifyContent="center" minHeight="60vh">
      <Stack gap="8" direction="column" alignItems="center">
        <img src={EmptyBriefs} alt="empty" width={250} height={188} />
        <Stack gap="2" direction="column" justifyContent="center" alignItems="center">
          <Heading as="h4" textAlign="center">
            <AppI18n k="empty.title" />
          </Heading>
          <Text textAlign="center" maxWidth="450px">
            <AppI18n k="empty.description" />
          </Text>
        </Stack>
      </Stack>
      <Stack gap="2" direction="column" justifyContent="center" alignItems="center">
        <CreateBriefButton title={<AppI18n k="empty.cta" />} />
        <BriefCreationHowToModal>
          <Button variant="ghost">
            <PlayCircleSolidIcon />
            <AppI18n k="empty.how_does_it_work" />
          </Button>
        </BriefCreationHowToModal>
      </Stack>
    </Stack>
  );
};
